module.exports = __webpack_public_path__ + "img/ISFJ.80a795d3.png";